import { steps } from "@/mocks/baogua";

export default function Features() {
  return (
    <section id="feature" className="relative w-full overflow-hidden bg-foreground-950 py-14 md:py-20">
      <div className="pointer-events-none absolute inset-0 opacity-20"
        style={{ backgroundImage: "radial-gradient(oklch(var(--accent-500)) 1px, transparent 1px)", backgroundSize: "22px 22px" }}></div>
      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-semibold text-primary-200">
            <i className="ri-route-line"></i> 一个瓜的完整旅程
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-bold text-background-50">
            爆瓜台<span className="font-display text-accent-300">四步</span>吃到好瓜
          </h2>
          <p className="mt-3 text-sm text-background-200/80 md:text-base">
            从线索捕捉到弹幕齐刷，我们保证每一次围观都既过瘾又有边界。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative flex flex-col rounded-2xl border border-background-800 bg-foreground-900 p-6 transition hover:border-accent-400/60">
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-accent-500 to-primary-500 text-2xl text-background-50">
                  <i className={s.icon}></i>
                </span>
                <span className="font-display text-3xl text-background-700">0{i + 1}</span>
              </div>
              <h3 className="mt-5 text-lg font-bold text-background-50">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200/75">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-2xl border border-background-800 bg-background-50/[0.03] p-6 sm:flex-row md:px-8">
          <p className="max-w-xl text-sm text-background-200/80 md:text-base">
            <i className="ri-shield-check-line mr-2 text-accent-400"></i>
            坚持内容原则：不造谣、不引导网暴、不做无聊的标题党。有边界地吃瓜，才是吃瓜的尽头。
          </p>
          <button onClick={() => document.getElementById("live")?.scrollIntoView({ behavior: "smooth" })}
            className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:opacity-90 transition">
            <i className="ri-live-line"></i> 现在就去开吃
          </button>
        </div>
      </div>
    </section>
  );
}